import { THREE } from '@powerplay/common';
export class TreesBatchingGenerator {
    static generate(name, gltf, position) {
        const data = [];
        gltf.scene.children.forEach((value, key) => {
            data[key] = {
                distance: position.distanceTo(value.position),
                position: value.position,
                rotation: new THREE.Vector3(value.rotation.x, value.rotation.y, value.rotation.z),
                scale: value.scale,
                name: value.name
            };
        });
        data.sort((a, b) => a.distance - b.distance);
        let output = `['${name}', {\n\tname: '${name}',\n\tdata: [\n`;
        const r = (n) => n.toFixed(2);
        data.forEach((value) => {
            output += `\t\t{\n\t\t\toffset: new THREE.Vector3(${r(value.position.x)}, `;
            output += `${r(value.position.y)}, ${r(value.position.z)}),\n\t\t\t`;
            output += `rotation: new THREE.Vector3(${r(value.rotation.x)}, ${r(value.rotation.y)}, `;
            output += `${r(value.rotation.z)}),\n\t\t\tscale: new THREE.Vector3(`;
            output += `${r(value.scale.x)}, ${r(value.scale.y)}, ${r(value.scale.z)}),`;
            output += '\n\t\t\tvirtual: false,\n\t\t},\n';
        });
        output += `\t],\n\tlayer: 0,\n\tmaxVisibleObjects: ${data.length},`;
        output += '\n\tlastVisibleObjectIndex: 0,\n\tnextIndex: 0,\n}],';
        console.log(output);
    }
}
//# sourceMappingURL=TreesBatchingGenerator.js.map